/* eslint-disable no-param-reassign */
// eslint-disable-next-line no-unused-vars
import { FETCH_FOLDERS_SUCCESS, UPDATE_APP_DATA } from 'constants/action_types'
import { createActionTypeReducer } from 'util/reducers'

// Example of how the folder looks in state
/*
{ 
  fol_0: {
    id: 'fol_0',
    name: 'Unassigned',
    position: 1,
    conditions: [],
    displayCountWhenInactive: true,
    matchType: 'all',
    queryId: 'folder:fol_0',
  }
}
*/

const byIdInitialState = {}

// Kevin Rademan (2021-02-24)
// Sigh......
// https://trello.com/c/2l54MNc5/392-hack-temporary-order-for-chat-folders-02
function hackGetFolderPosition(name, index) {
  switch (name) {
    case 'Unassigned':
      return 1
    case 'Mine':
      return 2
    case 'Assigned':
      return 3
    case 'Open':
      return 4
    case 'Snoozed':
      return 5
    case 'Closed':
      return 6
    case 'Trash':
      return 7
    case 'Spam':
      return 8
    default:
      return 8 + index
  }
}

// eslint-disable-next-line no-unused-vars
function byIdFetchFolderSuccessReducer(draftState, { data: { folders = [] } }) {
  folders.forEach((folder, index) => {
    const { id, name } = folder
    const folderId = `fol_${id}`
    draftState[folderId] = {
      ...folder,
      id: folderId,
      position: hackGetFolderPosition(name, index),
      queryId: `folder:${folderId}`,
    }
  })
  return draftState
}

export const byId = createActionTypeReducer(
  {
    [FETCH_FOLDERS_SUCCESS]: byIdFetchFolderSuccessReducer,
    [UPDATE_APP_DATA]: byIdFetchFolderSuccessReducer,
  },
  byIdInitialState
)
